import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button, Form, Modal } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { Optimize } from '@totem/components/ticketing/optimizeTypes';
import { ticketPermissions } from '@totem/components/ticketing/permissions';
import OptimizeForm from '@totem/components/ticketing/ticket/specialCases/optimizeForm';
import { defaultOptimize } from '@totem/components/ticketing/utilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import IBDIcon from '@totem/styles/Icon';
import { isNotNull } from '@totem/utilities/common';
import { TICKET_ENDPOINT } from '@totem/utilities/endpoints';
import { CheckResponseShowError } from '@totem/utilities/responseUtilities';
const styles = {
  form: {
    width: '100%',
  },
  formItem: {
    paddingBottom: '0',
    marginBottom: '1rem',
  },
};
const OptimizeEditButton = () => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const { onAction, ticket } = useContext(TicketContext);
  const [isSending, setIsSending] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [optimizeData, setOptimizeData] = useState<Optimize>(
    isNotNull(ticket) &&
      isNotNull(ticket.ticket.extras) &&
      isNotNull(ticket.ticket.extras.optimize)
      ? ticket.ticket.extras.optimize
      : { ...defaultOptimize },
  );

  useEffect(() => {
    if (
      isNotNull(ticket) &&
      isNotNull(ticket.ticket.extras) &&
      isNotNull(ticket.ticket.extras.optimize)
    ) {
      setOptimizeData(ticket.ticket.extras.optimize);
    }
  }, [ticket.ticket.project]);

  const sendOptimizeUpdate = useCallback(
    async (paramTicketId: string, payload: Optimize) => {
      if (!isSending) {
        fetch(`${TICKET_ENDPOINT}/${paramTicketId}/optimize`, {
          method: 'POST',
          headers: new Headers({
            Authorization: `Bearer ${getApiToken()}`,
          }),
          body: JSON.stringify(payload),
        }).then((res) => {
          setIsSending(false);
          const success = CheckResponseShowError(res);
          if (success) {
            setShowEdit(false);

            onAction('refresh', '');
          }
        });
      }
    }, // End async
    [],
  );

  const handleSubmit = () => {
    if (isNotNull(ticket) && isNotNull(ticket.ticket)) {
      sendOptimizeUpdate(ticket.ticket.id, optimizeData);
    }
  };

  return (
    <>
      {ticketPermissions.ticketOwner.hasPermissions(
        userProfile,
        ticket,
        null,
        null,
      ) && (
        <IBTooltip content={ticketPermissions.ticketOwner.tooltip}>
          <Button
            icon={<IBDIcon name={'Edit'} />}
            onClick={() => setShowEdit(true)}
          >
            Edit Optimize
          </Button>
        </IBTooltip>
      )}
      {showEdit && isNotNull(ticket) && (
        <Modal
          width={'800px'}
          open={showEdit}
          title="Update Optimize Opportunity"
          onCancel={() => {
            setShowEdit(false);
          }}
          onOk={handleSubmit}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                setShowEdit(false);
              }}
            >
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handleSubmit}>
              Submit
            </Button>,
          ]}
        >
          <Form layout="vertical" style={styles.form}>
            <OptimizeForm
              optimize={optimizeData}
              onChange={(optimizeUpdate: Optimize) => {
                setOptimizeData(optimizeUpdate);
              }}
            />
          </Form>
        </Modal>
      )}
    </>
  );
};
export default OptimizeEditButton;
